import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../components/layoutBlack";
import { config } from "../utils/constants";
import { clearCart } from "../store/slices/cartSlice.ts";

function PaymentSuccess() {
  const REACT_APP_API_URL = config.url.REACT_APP_API_URL;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const cart = useSelector((state) => state.cart);

  const dataFetchedRef = useRef(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const rehydrated = useSelector((state) => state._persist?.rehydrated);

  useEffect(() => {
    if (!rehydrated) return;

    const email =
      auth?.email ||
      cart?.shipping_info?.email ||
      cart?.billing_info?.email;

    const applied_promotion_code = cart?.applied_promotion_code;

    console.log("PaymentSuccess check:", {
      rehydrated,
      email,
      auth,
      cart,
      itemCount: cart?.items?.length,
    });

    if (dataFetchedRef.current) return;

    if (!email) {
      setError("Missing customer email.");
      setLoading(false);
      return;
    }

    if (!cart?.items?.length) {
      setError("Missing cart data.");
      setLoading(false);
      return;
    }

    dataFetchedRef.current = true;

    axios
      .post(`${REACT_APP_API_URL}/place-order/`, {
        email,
        applied_promotion_code,
      })
      .then((res) => {
        dispatch(clearCart());

        navigate("/thank-you", {
          state: {
            cart: res.data.cart,
            invoiceNumber: res.data.invoice_number,
            shippingAddress: res.data.customer_address || null,
          },
          replace: true,
        });
      })
      .catch((err) => {
        setError("Failed to place order.");
        console.error(err);
        setLoading(false);
        dataFetchedRef.current = false;
      });
  }, [rehydrated, auth, cart, dispatch, navigate, REACT_APP_API_URL]);

  return (
    <Layout>
      <section className="full-page-section bg0 p-t-120 p-b-80">
        <div className="container text-center">
          {loading && !error && <p className="lead">Placing your order...</p>}
          {error && <p className="text-danger">{error}</p>}
        </div>
      </section>
    </Layout>
  );
}

export default PaymentSuccess;